<template>
	<div class="input-container">
		<div class="input-loading"><span v-if="hasIcon" class="fa" :class="icon"></span><slot></slot></div>
	</div>
</template>

<script>

export default {

	props: {
		hasIcon: {
			type: Boolean,
			default: true,
		},
		icon: {
			type: String,
			default: 'fa-exclamation-triangle',
		},
	},

};

</script>
